<template>
  <div class="city-select">
    <div class="cs-left">
      <ul>
        <li>
          <span>按省份选择</span>
          <i class="el-icon-arrow-right"></i>
        </li>
      </ul>
    </div>
    <div class="cs-right" ref="csRight">
      <div class="csr-wrap">
        <div class="search-wrap">
          <el-input
            class="search-city"
            placeholder="请输入城市名称"
            suffix-icon="el-icon-search"
            v-model="searchCity"
            @input="handleInput">
          </el-input>
          <div class="search-result-wrap" v-if="searchResult">
            <el-scrollbar class="page-component__scroll" v-if="this.cityFilter.length > 0">
              <p v-for="item in cityFilter" :key="item.city" @click="handleChangeCity(item.city)">{{item.city}}</p>
            </el-scrollbar>
            <p v-else>抱歉，未能找到相关城市</p>
          </div>
          <span>当前城市：{{currentCity}}</span>
        </div>
        <ul class="letter-wrap">
          <li v-for="item in letterList" :key="item" @click="letterClick(item)"> {{item}} </li>
        </ul>
        <div class="city-list">
          <p>按照省份首字母选择</p>
          <div class="scoll-wrap">
            <el-scrollbar class="page-component__scroll" ref="pageComponentScroll">
              <template v-for="(item) in cityData">
                <div class="city-item" ref="letterCityItem" :key="item.letter" v-if="item.province.length > 0">
                  <div class="city-item-left">
                    <span>{{item.letter}}</span>
                  </div>
                  <div class="city-item-right">
                    <div class="city-province" v-for="(a, b) in item.province" :key="b">
                      <h6>{{a.province.replace(/省|自治区|壮族自治区|回族自治区|维吾尔自治区|特别行政区/, '')}}</h6>
                      <ul>
                        <li v-for="(c,d) in a.orgCityRegionDTO1s" :key="d" @click="handleChangeCity(c.city)">{{c.city}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </template>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http/index'
import {mapState, mapMutations} from 'vuex'
export default {
  data () {
    return {
      letterList: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
      cityData: {
        letterA: {
          letter: 'A',
          province: []
        },
        letterB: {
          letter: 'B',
          province: []
        },
        letterC: {
          letter: 'C',
          province: []
        },
        letterD: {
          letter: 'D',
          province: []
        },
        letterE: {
          letter: 'E',
          province: []
        },
        letterF: {
          letter: 'F',
          province: []
        },
        letterG: {
          letter: 'G',
          province: []
        },
        letterH: {
          letter: 'H',
          province: []
        },
        letterI: {
          letter: 'I',
          province: []
        },
        letterJ: {
          letter: 'J',
          province: []
        },
        letterK: {
          letter: 'K',
          province: []
        },
        letterL: {
          letter: 'L',
          province: []
        },
        letterM: {
          letter: 'M',
          province: []
        },
        letterN: {
          letter: 'N',
          province: []
        },
        letterO: {
          letter: 'O',
          province: []
        },
        letterP: {
          letter: 'P',
          province: []
        },
        letterQ: {
          letter: 'Q',
          province: []
        },
        letterR: {
          letter: 'R',
          province: []
        },
        letterS: {
          letter: 'S',
          province: []
        },
        letterT: {
          letter: 'T',
          province: []
        },
        letterU: {
          letter: 'U',
          province: []
        },
        letterV: {
          letter: 'V',
          province: []
        },
        letterW: {
          letter: 'W',
          province: []
        },
        letterX: {
          letter: 'X',
          province: []
        },
        letterY: {
          letter: 'Y',
          province: []
        },
        letterZ: {
          letter: 'Z',
          province: []
        }
      },
      searchCity: '',
      cityList: [], // 城市列表 用户搜索过滤
      cityFilter: [],
      searchResult: false
    }
  },
  computed: {
    ...mapState(['currentCity'])
  },
  created () {
    this.getOrgRegionInfo()
  },
  methods: {
    ...mapMutations(['handleCurrentCity']),
    handleInput (val) {
      if (!val) {
        this.cityFilter = []
        this.searchResult = false
        return false
      }
      this.searchResult = true
      this.cityFilter = this.cityList.filter(item => {
        if (val === item.city || val.toUpperCase() === item.city_initials || item.city.indexOf(val) !== -1) return item
      })
    },
    handleChangeCity (city) {
      this.searchResult = false
      this.searchCity = ''
      this.handleCurrentCity(city)
      this.$emit('handleChangeCity', city)
    },
    getOrgRegionInfo () {
      http.getOrgRegionInfo().then(res => {
        let data = res.data.data
        const temp = []
        data.forEach((item, index) => {
          temp.push(item.orgCityRegionDTO1s)
          if (item.provinceInitials === 'A') {
            this.cityData.letterA.province.push(item)
          }
          if (item.provinceInitials === 'B') {
            this.cityData.letterB.province.push(item)
          }
          if (item.provinceInitials === 'C') {
            this.cityData.letterC.province.push(item)
          }
          if (item.provinceInitials === 'D') {
            this.cityData.letterD.province.push(item)
          }
          if (item.provinceInitials === 'E') {
            this.cityData.letterE.province.push(item)
          }
          if (item.provinceInitials === 'F') {
            this.cityData.letterF.province.push(item)
          }
          if (item.provinceInitials === 'G') {
            this.cityData.letterG.province.push(item)
          }
          if (item.provinceInitials === 'H') {
            this.cityData.letterH.province.push(item)
          }
          if (item.provinceInitials === 'I') {
            this.cityData.letterI.province.push(item)
          }
          if (item.provinceInitials === 'J') {
            this.cityData.letterJ.province.push(item)
          }
          if (item.provinceInitials === 'K') {
            this.cityData.letterK.province.push(item)
          }
          if (item.provinceInitials === 'L') {
            this.cityData.letterL.province.push(item)
          }
          if (item.provinceInitials === 'M') {
            this.cityData.letterM.province.push(item)
          }
          if (item.provinceInitials === 'N') {
            this.cityData.letterN.province.push(item)
          }
          if (item.provinceInitials === 'O') {
            this.cityData.letterO.province.push(item)
          }
          if (item.provinceInitials === 'P') {
            this.cityData.letterP.province.push(item)
          }
          if (item.provinceInitials === 'Q') {
            this.cityData.letterQ.province.push(item)
          }
          if (item.provinceInitials === 'R') {
            this.cityData.letterR.province.push(item)
          }
          if (item.provinceInitials === 'S') {
            this.cityData.letterS.province.push(item)
          }
          if (item.provinceInitials === 'T') {
            this.cityData.letterT.province.push(item)
          }
          if (item.provinceInitials === 'U') {
            this.cityData.letterU.province.push(item)
          }
          if (item.provinceInitials === 'V') {
            this.cityData.letterV.province.push(item)
          }
          if (item.provinceInitials === 'W') {
            this.cityData.letterW.province.push(item)
          }
          if (item.provinceInitials === 'X') {
            this.cityData.letterX.province.push(item)
          }
          if (item.provinceInitials === 'Y') {
            this.cityData.letterY.province.push(item)
          }
          if (item.provinceInitials === 'Z') {
            this.cityData.letterZ.province.push(item)
          }
        })
        this.cityList = temp.flat(Infinity)
      })
    },
    letterClick (arg) {
      const letterCityItem = this.$refs.letterCityItem
      letterCityItem.forEach((item, index) => {
        const firstChildrenText = item.children[0].innerText
        if (arg !== firstChildrenText) return
        let offsetT = item.offsetTop // 获取元素距离顶部的距离
        this.ScrollTop(offsetT, 200)
      })
    },
    ScrollTop (number = 0, time) {
      if (!time) {
        this.$refs['pageComponentScroll'].wrap.scrollTop = number
        return number
      }
      const spacingTime = 20 // 设置循环的间隔时间  值越小消耗性能越高
      let spacingInex = time / spacingTime // 计算循环的次数
      let nowTop = (this.$refs['pageComponentScroll'].wrap.scrollTop) // 获取当前滚动条位置
      let everTop = (number - nowTop) / spacingInex // 计算每次滑动的距离
      let scrollTimer = setInterval(() => {
        if (spacingInex > 0) {
          spacingInex--
          this.ScrollTop((nowTop += everTop))
        } else {
          clearInterval(scrollTimer) // 清除计时器
        }
      }, spacingTime)
    }
  },
  mounted () {
    this.$refs.csRight.addEventListener('click', (e) => {
      if (e.target.className !== 'search-result-wrap') {
        this.searchResult = false
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.sass';
.city-select {
  overflow: hidden;
  .cs-left {
    width: 242px;
    height: 100%;
    background: url("~@/assets/images/selectbg.png") no-repeat;
    background-size: cover;
    float: left;
    ul {
      padding: 18px 0;
      li {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 20px 20px;
        background: rgba(27, 56, 202, .1);
        font-size: 18px;
        color: #fff;
      }
    }
  }
  .cs-right {
    width: 958px;
    background: #fff;
    float: left;
    .csr-wrap {
      padding: 28px 38px 0;
      .search-wrap {
        display: flex;
        align-items: center;
        position: relative;
        .search-result-wrap {
          width: 580px;
          height: 200px;
          position:absolute;
          top: 37px;
          left: 0;
          z-index: 1;
          background: #fff;
          box-shadow: 0px 0px 20px rgba(0,0,0,.1);
          border-radius: 5px;
          p {
            line-height: 30px;
            padding:0 20px;
            color: #101D37;
            font-size: 14px;
            &:hover {
              background: #f8f8f9;
              color: $el-main-color;
            }
          }
        }
        .search-city {
          width: 580px;
          height: 36px;
          margin-right: 25px;
        }
        span {
          font-size: 16px;
          color: #8C8E9E;
        }
      }
      .letter-wrap {
        display: flex;
        justify-content: space-around;
        margin: 24px 0 14px;
        li {
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          font-size: 16px;
          color: #474964;
          border-radius: 50%;
          &:hover {
            background:#F6F7F9;
          }
        }
      }
      .city-list {
        p {
          font-size: 16px;
          color: #101D37;
          font-weight: bold;
        }
        .scoll-wrap {
          height: 380px;
          border: 1px solid #DDDDDD;
          border-radius: 5px;
          margin-top: 19px;
          &.active {
            animation: shake .3s ease-in-out;
          }
          .city-item {
            border-bottom: 1px solid #DDDDDD;
            position: relative;
            &:last-child {
              border-bottom: none;
            }
            .city-item-left {
              position: absolute;
              top: 0;
              bottom: 0;
              width: 55px;
              background-color: #F6F7F9;
              font-size: 18px;
              color: #101D37;
              text-align: center;
              font-weight: bold;
              span {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 24px;
                line-height: 24px;
                margin: auto;
                font-size: 24px;
              }
            }
            &:hover {
              .city-item-left {
                background: $el-main-color;
                color: #fff;
              }
            }
            .city-item-right {
              margin-left: 55px;
              .city-province {
                padding: 14px 0;
                line-height: 27px;
                position: relative;
                &::after {
                  content: '';
                  display: block;
                  width:0;
                  height:0;
                  border-top:8px solid transparent;
                  border-bottom: 8px solid transparent;
                  border-left: 8px solid $el-main-color;
                  position: absolute;
                  left: 0px;
                  top: 20px;
                  opacity: 0;
                }
                &:hover::after {
                  opacity: 1;
                }
                h6 {
                  width: 60px;
                  float: left;
                  margin-left: 25px;
                  font-weight: bold;
                  font-size: 16px;
                  color: #101D37;
                }
                ul {
                  margin-left: 85px;
                  padding-right: 8px;
                  li {
                    display: inline-block;
                    margin-right: 12px;
                    cursor: pointer;
                    color: #101D37;
                    font-size: 14px;
                    &:hover {
                      color: $el-main-color;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
.search-city /deep/ .el-input__inner {
  height: 36px;
  background: #F6F7F9;
  border-radius: 18px;
}
/deep/ .page-component__scroll {
  height: 100%;
}
/deep/ .page-component__scroll .el-scrollbar__wrap{
  overflow-x: auto;
}
@keyframes shake {
  0% { transform: translate3d(-2px, 0, 0) }
  25% { transform: translate3d(2px, 0, 0) }
  50% { transform: translate3d(-2px, 0, 0) }
  75% { transform: translate3d(2px, 0, 0) }
  100% { transform: translate3d(0px, 0, 0)}
}
</style>



// WEBPACK FOOTER //
// src/layout/city.vue